import AdminModal from "../../../components/AdminModal";
import {
  formatTravelDate,
  formatTime,
  getBookingType,
  formatPaxData,
  formatLuggageData,
  formatChildSeatData,
  getMeetAssistNames,
} from "../../../../../actions/admin/quotation";
// import edit_gold_icon from "../../../../../icons/dashboard/edit_gold_icon.svg";
// import copy_gold from "../../../../../icons/dashboard/copy_gold.svg";
// import trash_icon from "../../../../../icons/dashboard/trash-icon.svg";
// import arrow_outward_icon from "../../../../../icons/dashboard/arrow_outward_icon.svg";
import {
  CopyIcon,
  EditIcon,
  DeleteIcon,
  ArrowOutwardIcon
} from "../../../../icons"

const TransferDetailModal = ({
  show,
  onClose,
  detailTransfer,
  quotationDetail,
  onEdit,
  onDuplicate,
  onDelete,
}) => {
  // Once the customer has authorized payment (anything past NOT_PAID) the
  // quotation is locked and its Booking records exist.
  const isPaymentLocked =
    Boolean(quotationDetail?.paymentStatus) &&
    quotationDetail.paymentStatus !== "NOT_PAID";
  const isDisabled =
    isPaymentLocked || quotationDetail?.quotationStatus === "EXPIRED";

  return (
    <AdminModal
      show={show}
      size="modal-lg"
      title={"Transfer Details"}
      onClose={onClose}
    >
      <div className="row">
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Item ID</p>
          <p>#{detailTransfer?.key}</p>
        </div>
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Travel Date</p>
          <p>{formatTravelDate(detailTransfer?.travelDate)}</p>
        </div>
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Transfer Type</p>
          <p>
            {getBookingType(
              detailTransfer?.bookingType,
              detailTransfer?.isAirportTransfer
            )}
          </p>
        </div>
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Passenger's Name</p>
          <p>
            {!detailTransfer?.passengerName
              ? "-"
              : `${detailTransfer?.passengerPronounced} ${detailTransfer?.passengerName}`}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Start Time (From Garage)</p>
          <p>
            {formatTravelDate(detailTransfer?.startFromGarage) +
              ", " +
              formatTime(detailTransfer?.startFromGarage)}
          </p>
        </div>
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Pick-up Time</p>
          <p>
            {formatTravelDate(detailTransfer?.travelDate) +
              ", " +
              detailTransfer?.pickupTime}
          </p>
        </div>
        <div className="col-6">
          <p className="mb-0 fs-12 text-A7A7A7">Pick-up Location</p>
          <p>{detailTransfer?.pickupLocation?.formatted_address}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Arrival Time (To Garage)</p>
          <p>
            {formatTravelDate(detailTransfer?.garageArivalTime) +
              ", " +
              formatTime(detailTransfer?.garageArivalTime)}
          </p>
        </div>
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Estimated Drop-off Time</p>
          <p>
            {formatTravelDate(detailTransfer?.customerDropoffDateTime) +
              ", " +
              formatTime(detailTransfer?.customerDropoffDateTime)}
          </p>
        </div>
        <div className="col-6">
          <p className="mb-0 fs-12 text-A7A7A7">Drop-off Location</p>
          {detailTransfer?.destinations?.map((item, index) => (
            <p className="py-0 m-0 p-0" key={index}>
              ({index + 1}) {item.formatted_address}
            </p>
          ))}
          <br />
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Vehicle</p>
          <p>
            {detailTransfer?.bookingItems
              .filter((item) => item.type === "vehicle")
              .reduce((acc, v) => {
                const existingItem = acc.find((i) => i.name === v.name);
                if (existingItem) {
                  existingItem.qty += v.qty;
                } else {
                  acc.push({ name: v.name, qty: v.qty });
                }
                return acc;
              }, [])
              .map((v, i) => (
                <span key={i}>
                  {v.name} x{v.qty}{" "}
                </span>
              ))}
          </p>
        </div>
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Passengers</p>
          <p>{formatPaxData(detailTransfer?.pax)}</p>
        </div>
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Luggage</p>
          <p>{formatLuggageData(detailTransfer?.luggage)}</p>
        </div>
        <div className="col-3">
          <p className="mb-0 fs-12 text-A7A7A7">Add-on Services</p>
          <p>
            {formatChildSeatData(detailTransfer?.childSeat)} <br />
            {getMeetAssistNames(detailTransfer?.bookingItems)}
          </p>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-6">
          <p className="mb-0 fs-12 text-A7A7A7">Message・Inquiry</p>
          <p>
            {detailTransfer?.message?.length > 0
              ? detailTransfer.message[0]?.note
              : "-"}
          </p>
        </div>
      </div>

      {isPaymentLocked ? (
        <div className="row justify-content-center">
          <div className="col-4">
            <div className="d-grid">
              <button
                className="btn btn-outline-default rounded"
                onClick={() =>
                  window.open(
                    `/admin/bookinglist/edit/v2/${detailTransfer?._id}`,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <div className="tw:flex tw:!justify-center tw:!items-center">
                  <ArrowOutwardIcon className="me-2" color="#DBBE78" />
                  <p className="m-0">Booking Detail</p>
                </div>
              </button>
            </div>
          </div>
        </div>
      ) : !isDisabled && (
        <div className="row justify-content-center">
          <div className="col-4">
            <div className="d-grid">
              <button
                className="btn btn-outline-default rounded"
                onClick={onEdit}
              >
                <div className="tw:flex tw:!justify-center tw:!items-center">
                  {/* <img src={edit_gold_icon} alt="" srcSet="" className="me-2" /> */}
                  <EditIcon className="me-2" />
                  <p className="m-0">Edit</p>
                </div>
              </button>
            </div>
          </div>
          <div className="col-4">
            <div className="d-grid">
              <button
                className="btn btn-outline-default rounded"
                onClick={onDuplicate}
              >
                <div className="tw:flex tw:!justify-center tw:!items-center">
                  {/* <img src={copy_gold} alt="" srcSet="" className="me-2" /> */}
                  <CopyIcon className="me-2" />
                  <p className="m-0">Duplicate Transfer</p>
                </div>
              </button>
            </div>
          </div>
          <div className="col-4">
            <div className="d-grid">
              <button
                className="btn bg-EA4335 rounded"
                onClick={onDelete}
              >
                <div className="tw:flex tw:!justify-center tw:!items-center">
                  {/* <img src={trash_icon} alt="" srcSet="" className="me-2" /> */}
                  <DeleteIcon className="me-2" />
                  <p className="m-0 text-white">Delete Transfer</p>
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminModal>
  );
};

export default TransferDetailModal;
